import React from 'react';
import { Link } from 'react-router-dom';

export class BundleDisplayChanel extends React.Component {
  render() {
    return <section id='BundleDisplayChanel'></section>;
  }
}

export default BundleDisplayChanel;
